import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { tc, tbr } from "../lib/themeStyles";

const NAV_LINKS = [
  { href: "#capabilities", label: "Capabilities" },
  { href: "#materials", label: "Materials" },
  { href: "#supply-chain", label: "Supply Chain" },
  { href: "#rfq", label: "Submit RFQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "navbar-glass" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3.5 shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="Malunjkar Engineering Company logo"
            width={80}
            height={80}
            className="h-20 w-20 rounded-full object-cover ring-1 ring-white/10 mix-blend-screen"
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="text-[21px] font-extrabold tracking-[-0.02em]" style={tc.primary}>
              MALUNJKAR
            </span>
            <span className="text-[12px] font-medium tracking-wide" style={tc.muted}>
              Engineering Co.
            </span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="link-reveal text-[14px] font-medium">
              {l.label}
            </a>
          ))}
          <a href="#rfq" className="btn-primary !py-[10px] !px-5 text-[14px]">
            Request Quote
          </a>
        </nav>
        <button
          type="button"
          className="md:hidden p-1"
          style={tc.primary}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div
          className="md:hidden border-t backdrop-blur-xl animate-slide-down"
          style={{ ...tbr.default, background: "rgba(5, 5, 15, 0.95)" }}
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[15px] font-medium"
                style={tc.primary}
              >
                {l.label}
              </a>
            ))}
            <a href="#rfq" onClick={() => setOpen(false)} className="btn-primary text-center mt-2 justify-center">
              Request Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
